import {useFetchFinancial} from '~/services'
import {DashboardPage} from '../components/dashboard_page'
import {graphVariantsTaxonomy} from './graph_variants_taxonomy'

export const FinancialDashboard = () => {
	useFetchFinancial()

	return <DashboardPage graphVariantsTaxonomy={graphVariantsTaxonomy} name="financial" />
}
